<template>
    <div class="highcharts" :id="id"></div>
</template>

<script>
    import HighCharts from 'highcharts'
    export default {
        name: "highcharts",
        props:['option','id'],
        watch: {
            option:{
                handler(val){
                    HighCharts.chart(this.id,this.option);
                },
                deep:true
            },
        },
        mounted() {
            HighCharts.chart(this.id,this.option)
        }
    }
</script>

<style lang="less" scoped>
    .highcharts{width:100%;height:100%;}
</style>